(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lilafix-shade-chart"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializedCharts = new WeakSet();
    const normalizeQuery = value => String(value || '')
      .normalize('NFKD')
      .replace(/\p{M}/gu, '')
      .toLocaleLowerCase()
      .replace(/ı/g, 'i')
      .replace(/[\s.,/\\_-]+/g, '');

    function initShadeCharts(root = document) {
      const charts = Array.from(root.querySelectorAll('[data-shade-chart]'));
      if (root.matches && root.matches('[data-shade-chart]')) charts.unshift(root);
      charts.forEach(chart => {
        if (initializedCharts.has(chart)) return;
        initializedCharts.add(chart);
        const links = Array.from(chart.querySelectorAll('[data-shade-variant]'));
        const selector = document.getElementById(chart.dataset.variantSelect);
        const nativeSelect = selector && selector.matches('select[data-hair-colour]') ? selector : null;
        const preview = chart.querySelector('[data-shade-preview]');
        const media = chart.querySelector('[data-shade-preview-media]');
        const image = chart.querySelector('[data-shade-preview-image]');
        const title = chart.querySelector('[data-shade-preview-title]');
        const selectedLabel = chart.querySelector('[data-shade-selected-label]');
        const price = chart.querySelector('[data-shade-preview-price]');
        const availability = chart.querySelector('[data-shade-preview-availability]');
        const search = chart.querySelector('[data-shade-search]');
        const query = chart.querySelector('[data-shade-query]');
        const count = chart.querySelector('[data-shade-count]');
        const empty = chart.querySelector('[data-shade-empty]');
        const purchaseDetails = chart.dataset.purchaseDetails === 'true';

        const showSelection = value => {
          const chosen = links.find(link => link.dataset.shadeVariant === String(value));
          links.forEach(link => {
            if (link === chosen) link.setAttribute('aria-current', 'true');
            else link.removeAttribute('aria-current');
          });
          const imageUrl = chosen ? chosen.dataset.previewUrl : '';
          media.hidden = !imageUrl;
          if (imageUrl) {
            image.src = imageUrl;
            image.hidden = false;
          } else {
            image.removeAttribute('src');
            image.hidden = true;
          }
          image.alt = chosen ? chosen.dataset.alt : '';
          preview.toggleAttribute('data-empty', !chosen);
          title.textContent = chosen ? chosen.dataset.title : chart.dataset.choose;
          if (chosen) title.setAttribute('translate', 'no');
          else title.removeAttribute('translate');
          selectedLabel.hidden = !chosen;
          price.hidden = !(chosen && purchaseDetails && chosen.dataset.price);
          price.textContent = chosen && purchaseDetails ? chosen.dataset.price || '' : '';
          availability.hidden = !chosen;
          availability.textContent = chosen
            ? chosen.dataset.available === 'true' && purchaseDetails
              ? chart.dataset.inStock : chart.dataset.unavailable
            : '';
        };

        const updateVariantUrl = value => {
          const url = new URL(window.location.href);
          if (value) url.searchParams.set('variant', value);
          else url.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', url);
        };

        links.forEach(link => {
          link.addEventListener('click', event => {
            if (event.defaultPrevented || event.button !== 0 || event.metaKey
              || event.ctrlKey || event.shiftKey || event.altKey || !nativeSelect) return;
            const option = Array.from(nativeSelect.options)
              .find(item => item.value === link.dataset.shadeVariant);
            if (!option) return;
            event.preventDefault();
            nativeSelect.value = option.value;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });

        if (nativeSelect) {
          nativeSelect.addEventListener('change', () => {
            showSelection(nativeSelect.value);
            updateVariantUrl(nativeSelect.value);
          });
          showSelection(nativeSelect.value);
        }

        search.hidden = false;
        query.addEventListener('input', () => {
          const needle = normalizeQuery(query.value);
          const numericQuery = /^\d/.test(needle);
          let visible = 0;
          links.forEach(link => {
            const shadeCode = link.dataset.title.replace(/^(?:Candy|Exclusive)\s+/i, '');
            const matches = !needle || (numericQuery
              ? normalizeQuery(shadeCode).startsWith(needle)
              : normalizeQuery(link.dataset.title).includes(needle));
            link.hidden = !matches;
            if (matches) visible += 1;
          });
          empty.hidden = visible !== 0;
          count.textContent = chart.dataset.countTemplate.replace('__COUNT__', String(visible));
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initShadeCharts(), { once: true });
    } else {
      initShadeCharts();
    }
    document.addEventListener('shopify:section:load', event => initShadeCharts(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    function initializeProductGalleries(scope) {
    scope.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      if (gallery.hasAttribute('data-gallery-enhanced')) return;
      const track = gallery.querySelector('[data-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      if (!track || slides.length < 2) return;
      const previous = gallery.querySelector('[data-gallery-previous]');
      const next = gallery.querySelector('[data-gallery-next]');
      const thumbnails = Array.from(gallery.querySelectorAll('[data-gallery-thumbnail]'));
      const current = gallery.querySelector('[data-gallery-current]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let scrollFrame = 0;

      function synchronize() {
        if (!track.clientWidth) return;
        activeIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;
        current.textContent = String(activeIndex + 1);
        thumbnails.forEach((thumbnail, index) => {
          thumbnail.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
        });
        slides.forEach((slide, index) => {
          slide.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true');
        });
      }

      function showSlide(index) {
        const target = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: target * track.clientWidth, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      }

      previous.addEventListener('click', () => showSlide(activeIndex - 1));
      next.addEventListener('click', () => showSlide(activeIndex + 1));
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => showSlide(index));
      });
      gallery.addEventListener('keydown', event => {
        const thumbnail = event.target.closest('[data-gallery-thumbnail]');
        if (event.target !== track && !thumbnail) return;
        const startingIndex = thumbnail ? Number(thumbnail.getAttribute('data-gallery-thumbnail')) : activeIndex;
        let target;
        if (event.key === 'ArrowLeft') target = startingIndex - 1;
        else if (event.key === 'ArrowRight') target = startingIndex + 1;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = slides.length - 1;
        else return;
        event.preventDefault();
        target = Math.max(0, Math.min(slides.length - 1, target));
        showSlide(target);
        if (thumbnail) {
          thumbnails[target].focus({ preventScroll: true });
          thumbnails[target].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      });
      track.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = 0;
          synchronize();
        });
      }, { passive: true });
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => {
          track.scrollTo({ left: activeIndex * track.clientWidth, behavior: 'instant' });
          synchronize();
        }).observe(track);
      }
      gallery.setAttribute('data-gallery-enhanced', 'true');
      gallery.querySelectorAll('[data-gallery-controls]').forEach(control => { control.hidden = false; });
      synchronize();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeProductGalleries(document), { once: true });
  } else {
    initializeProductGalleries(document);
  }
  document.addEventListener('shopify:section:load', event => initializeProductGalleries(event.target));
  } catch(e) { console.error(e); }
})();

})();
